import React from 'react'
import { Box, Grid, Typography } from '@mui/material';
import { formStyle, stepNumberStyle, formTitleStyle, formDesStyle, topUnderlineStyle, sectionContainer, lastStepTitle, lastStepDesc } from '../../../constant/material_style';
import lastStepImg from '../../../assets/last_step_img.png';
import lastStepMobileImg from '../../../assets/last_step_mobile.png';

const LastStep = ({ currentStep, setCurrentStep, formValues }) => {
	const goback = (e) => {
		e.preventDefault();
		setCurrentStep(currentStep - 1);
	}

	const handleSubmit = (e) => {
		e.preventDefault(e);
	}

	return (
		<form onSubmit={(e) => handleSubmit(e)}>
			<Box style={formStyle}>
				<Grid container alignItems="flex-start" spacing={2} style={{ marginBottom: '20px', overflowY: 'auto' }}>
					<Grid item>
						<Box style={stepNumberStyle}>{currentStep}</Box>
					</Grid>
					<Grid item xs style={{ paddingLeft: '0' }}>
						<Typography style={formTitleStyle}>Welcome to Komune Care</Typography>
						<Typography style={formDesStyle}>For the quality of life and wellness you deserve</Typography>
					</Grid>
				</Grid>

				{/* per section */}
				<Box style={{ marginBottom: '20px' }}>
					<Box style={topUnderlineStyle}>
						<Typography style={formDesStyle}>Comprehensive Senior Care and Integrated Community Living</Typography>
					</Box>
				</Box>

				<Box style={sectionContainer}>
					<div className="image-container">
						<img src={lastStepImg} className='desktop-image' alt="Welcome to Komune Care" />
						<img src={lastStepMobileImg} className='mobile-image' alt="Welcome to Komune Care" />
					</div>
				</Box>

				<Box style={sectionContainer}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<Typography style={lastStepTitle}>
								Explore a new lifestyle
							</Typography>
							<Typography style={lastStepDesc}>We care about you and your loved ones. Find out more about our premium nursing homes and home care</Typography>
						</Grid>
					</Grid>
				</Box>
				<div style={{ marginTop: '40px' }}></div>

				<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
					<button className='t-accept-button' onClick={goback}>Previous</button>
					<button type="submit" className='t-accept-button'>Submit</button>
				</div>
			</Box>
		</form>
	);
}

export default LastStep